var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "96px",
    height: "96px",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(39.607843%,40%,40%)",
      fillOpacity: 1
    },
    d: "M 54.355469 27.140625 L 50.417969 11.277344 L 36.46875 13.472656 C 35.550781 13.613281 34.699219 12.996094 34.546875 12.074219 L 34.339844 10.761719 C 34.199219 9.84375 34.816406 8.988281 35.738281 8.839844 L 52.125 6.269531 C 53.136719 6.113281 54.113281 6.761719 54.355469 7.753906 L 58.894531 26.015625 C 59.121094 26.917969 58.566406 27.824219 57.667969 28.050781 L 56.378906 28.371094 C 55.488281 28.59375 54.574219 28.042969 54.355469 27.140625 Z M 54.355469 27.140625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,61.568627%,0%)",
      fillOpacity: 1
    },
    d: "M 6.019531 70.300781 C 6.019531 79.441406 13.429688 86.847656 22.566406 86.847656 C 31.707031 86.847656 39.113281 79.441406 39.113281 70.300781 C 39.113281 61.167969 31.707031 53.753906 22.566406 53.753906 C 13.429688 53.753906 6.019531 61.167969 6.019531 70.300781 Z M 6.019531 70.300781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.784314%,72.941176%,30.196078%)",
      fillOpacity: 1
    },
    d: "M 15.394531 56.371094 C 18.074219 57.722656 20.953125 58.277344 23.746094 58.125 C 23.363281 52.488281 20.097656 47.191406 14.691406 44.464844 C 12.011719 43.113281 9.128906 42.5625 6.339844 42.714844 C 6.722656 48.355469 9.984375 53.644531 15.394531 56.371094 Z M 15.394531 56.371094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,66.666667%,100%)",
      fillOpacity: 1
    },
    d: "M 80.660156 86.894531 L 50.871094 86.894531 C 49.183594 86.894531 47.785156 85.746094 47.636719 84.246094 L 42.011719 27.832031 C 41.941406 27.140625 42.550781 26.53125 43.339844 26.53125 L 88.265625 26.53125 C 89.050781 26.53125 89.660156 27.140625 89.589844 27.832031 L 83.644531 84.457031 C 83.503906 85.839844 82.207031 86.894531 80.660156 86.894531 Z M 80.660156 86.894531 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c0b246cdc03b202e3148cc748554dcf0.svg";
export { ForwardRef as ReactComponent };